module.exports = __webpack_public_path__ + "static/media/close-icon.b82be467.svg";